<template>
    <Row>
        <i-col span="12">
    <Tree :data="data3" @on-select-change="updte"  ></Tree>
    <Button type="primary" @click="addmenu" v-if="privilegesbtn('/menu/create')">新增</Button>
     <Button type="primary" @click="deletemenu" v-if="privilegesbtn('/menu/delete')">删除</Button>
    </i-col>
        <i-col span='12'>
           
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
            <Alert show-icon>{{title}}</Alert>
            <FormItem label="菜单名称" prop="name">
                <i-input v-model="formValidate.name" placeholder="请输入菜单名称"></i-input>
            </FormItem>
            <FormItem label="菜单图标" prop="icon">
              <i-input v-model="formValidate.icon"></i-input>
            </FormItem>
             <FormItem label="上级菜单">
                         <Select v-model="menu.lev1" style="width:100px" @on-change="changedata()">
                            <Option v-for="item in menudata" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                         <Select v-model="menu.lev2" style="width:100px" v-if="menu.lev1&&isshow">
                            <Option v-for="item in menudata[myindex].submenu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                         <Button type="primary" @click="menuinit()">重置</Button>  
             </FormItem>
             <FormItem label="链接地址" prop="link">
                    <i-input v-model="formValidate.link" placeholder="请输入链接地址"></i-input>
             </FormItem>
              <FormItem label="排序" prop="sort">
                    <i-input v-model="formValidate.sort" placeholder="请输入排序"></i-input>
             </FormItem>
             <FormItem label="是否显示" prop="shown">
                  <RadioGroup v-model="formValidate.shown">
                    <Radio label="1">是</Radio>
                    <Radio label="0">不是</Radio>
                </RadioGroup>
             </FormItem> 
            <FormItem>
                <Button type="primary" @click="handleSubmitn('formValidate')"  v-if="title!='菜单详情'">提交</Button>
            </FormItem>
        </Form>
        </i-col>
    </Row>
</template>
<script>
import { mapState } from "vuex";
import privilegesbtn from "../../constant/privilegesbtn.js";
import {
  menuindex,
  createmenu,
  updatemenu,
  deletemenu
} from "../../api/menuapi";
export default {
  data() {
      const validatemenu_id = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择菜单"));
      } else {
        console.log(this.id)
        if(this.title=="编辑菜单"&&!this.id){
          callback(new Error('请选择左侧菜单进行编辑'))
        }else{
             callback()
        } 
      }
    };
    return {
      data3: [
        {
          title: "菜单",
          loading: false,
          expand: true,
          children: []
        }
      ],

      title: "菜单详情",
      formValidate: {
        name: "",
        icon: "",
        link: "",
        sort: "",
        shown: "1",
        sup_menu_id: ""
      },
      menudata: [],
      menudata1: [],
      ruleValidate: {

        name: [{ validator: validatemenu_id, trigger: "blur" }]
      },
      myindex: 0,
      isshow: false,
      menu: {
        lev1: "",
        lev2: ""
      }
    };
  },
  methods: {
    privilegesbtn: privilegesbtn,
    handleSubmitn(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.menu.lev1) {
            this.formValidate.sup_menu_id = this.menu.lev1;
            if (this.menu.lev2) {
              this.formValidate.sup_menu_id = this.menu.lev2;
            }
          }
          if (this.title == "新增菜单") {
            this.createmenu();
          } else if (this.title == "编辑菜单") {
            this.updatemenu();
          }
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    getmenulist() {
      var par = {};
      menuindex(par).then(res => {
        var data = res.data;
        if (data.code == 1) {
          this.menudata = data.data;
          // this.$store.commit("GETmenudata", data.data);
          this.getdata();
        }
      });
    },
    getdata() {
      this.data3 = [
        {
          title: "菜单",
          loading: false,
          expand: true,
          children: []
        }
      ];
      this.menudata.forEach(element => {
        let data = {};
        if (element.submenu && element.submenu.length > 0) {
          data.children = [];
          data.data = element;
          data.title = element.name;
          data.expand = true;
          data.loading = false;
          element.submenu.forEach(item => {
            if (item.submenu && item.submenu.length > 0) {
              let mindata = {
                title: item.name,
                data: item,
                loading: false,
                children: []
              };
              item.submenu.forEach(value => {
                mindata.children.push({
                  title: value.name,
                  famenuid: item.sup_menu_id,
                  data: value
                });
              });
              data.children.push(mindata);
            } else {
              data.children.push({
                title: item.name,
                data: item
              });
            }
          });
        } else {
          data.title = element.name;
          data.data = element;
        }
        this.data3[0].children.push(data);
      });
    },
    changedata() {
      this.menudata.forEach((element, index) => {
        if (element.id == this.menu.lev1) {
          this.myindex = index;
          if (element.submenu && element.submenu.length > 0) {
            this.isshow = true;
          } else {
            this.isshow = false;
          }
        }
      });
    },
    createmenu() {
      let par = this.formValidate;
      createmenu(par).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.itin();
          this.menuinit();
          this.getmenulist();
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    updatemenu() {
      let par = this.formValidate;
      par.id = this.id;
      if (!par.id) {
        this.$Message.warning("请先选择一个菜单");
        return false;
      }
      updatemenu(par).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.getmenulist();
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    deletemenu() {
      var _this = this;
      if (!_this.id) {
        this.$Message.warning("请先选择一个菜单");
        return false;
      }
      this.$Modal.confirm({
        title: "菜单列表",
        content: `是否删除此菜单`,
        onOk: function() {
          this.$Loading.start();
          let para = { id: _this.id };
          deletemenu(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              _this.$Message.success(data.message);
              _this.getmenulist();
            } else {
              _this.$Message.error(data.message);
            }
          });
        }
      });
    },
    menuinit() {
      this.formValidate.sup_menu_id = null;
      this.isshow = false;
      this.menu.lev1 = null;
      this.menu.lev2 = null;
    },
    addmenu() {
      this.title = "新增菜单";
      this.formValidate = {
        name: "",
        icon: "",
        link: "",
        sort: "",
        shown: "1",
        sup_menu_id: ""
      };
      this.menuinit();
    },
    //初始化表单
    itin() {
      this.formValidate = {
        name: "",
        icon: "",
        link: "",
        sort: "",
        shown: "1",
        sup_menu_id: ""
      };
    },
    updte(res) {
      if (this.privilegesbtn("/menu/update")) {
        if (res && res.length > 0) {
          var data = res[0].data;
          this.formValidate.name = data.name;
          this.formValidate.icon = data.icon;
          this.formValidate.link = data.link;
          if (data.level == 2) {
            this.menu.lev1 = data.sup_menu_id;
            this.menu.lev2 = null;
          } else if (data.level == 3) {
            this.menu.lev2 = data.sup_menu_id;
            this.menu.lev1 = res[0].famenuid;
          } else {
            this.formValidate.sup_menu_id = null;
            this.menu.lev1 = null;
            this.menu.lev2 = null;
          }
          this.formValidate.sup_menu_id = data.sup_menu_id;
          console.log("1" + this.formValidate.sup_menu_id);
          this.formValidate.sort = data.sort;
          this.formValidate.shown = data.shown + "";
          this.id = data.id;
          this.title = "编辑菜单";
        }
      } else {
      }
    }
  },
  mounted() {
    this.getmenulist();
  }
};
</script>
            


// WEBPACK FOOTER //
// src/pages/menu/index.vue